<div
  class="select"
  [class]="customClass"
  (click)="toggleOpen()"
  [class.placeholderShown]="val === placeholder"
  [class.select_disabled]="isDisabled"
  (clickOutside)="closeDropdown()"
>
  <div *ngIf="isMobile; else customSelect" class="select__native">
    <select class="select__browser-element" (change)="nativeChange($event)" [value]="val" name="select">
      <option disabled [selected]="placeholder === val">
        {{ placeholder }}
      </option>
      <option *ngFor="let item of items" [selected]="item === val" [value]="item" [label]="item">
        {{ item }}
      </option>
    </select>
    <img src="assets/img/icons/blue-triangle_down.svg" alt="" class="select__arrow" />
  </div>
  <ng-template #customSelect>
    <div class="select__wrap" [class.active]="isOpen">
      <div class="select__title">
        <span class="select__title-text" [title]="val">{{ titleText }}</span>
        <img
          src="assets/img/icons/blue-triangle_down.svg"
          alt=""
          [class.active]="isOpen"
          class="select__arrow"
        />
      </div>
      <div class="select__list" [class.active]="isOpen">
        <ul class="select__list-inner">
          <li class="select__item" (click)="setValue(item)" *ngFor="let item of items">
            {{ item }}
          </li>
        </ul>
      </div>
    </div>
  </ng-template>
</div>
